<template>
    <section>
        <sy-baselist
                listUrl="server/system/Message.ashx?cmd=GetList"
                hideAdd
                mutilSelect
                title="业务消息"
                hideOperate
                ref="Message"
                :fixWhere = "fixWhere"
                :showSelecttion="true"
                @onMultipleSelect="onMultipleSelect"
                deleteAllUrl="server/system/Message.ashx?cmd=DeleteAll"
        >
            <el-table-column >
                <template scope="scope">
                    <span class="message-dot" v-if="showDot(scope.row)"></span>
                    <a class="detail" href="javascript:;" @click="viewMessage(scope.row)">{{getFtitle(scope.row)}}{{ scope.row.detail }}</a>
                </template>
            </el-table-column>
            <el-table-column width="200px">
                <template scope="scope">
                    {{scope.row.sendDate | formatDate2}}
                </template>
            </el-table-column>
            <template  slot="extendbtnTop">
                <el-button v-if="showReadBtn" type="primary" size="small" @click="handleSetRead">设置已读</el-button>
                <el-button  type="success" size="small"   @click="Reflash">刷新</el-button>
            </template>
        </sy-baselist>
    </section>
</template>

<script>
    import Vue from 'Vue'
    import util from '../common/util'
    import mixin from '../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
               showReadBtn:false,
              fixWhere:"FType=0"
            }
        },
        methods:{
            getFtitle(row){
                if(row.title) {
                    return "【" + row.title + "】"
                }
                return ''
            },
            viewMessage(row){
                util.post("server/system/Message.ashx?cmd=Read",{id:row.id},null,result=>{
                    this.$refs.Message._refrash();
                    global.bus.$emit('RefreshMsgCount')
                })
            },
            createEditForm(editVue){
                if(editVue) {
                    debugger
                    let C = Vue.extend(require(editVue))
                    let form = new C()
                    form.$on("onSaveSuc", this.onSaveSuc)
                    this.$el.appendChild(form.$mount().$el)
                    //form子组件为el-dialog
                    //这里要销毁，以免使用相同窗体，状态保留出错
                    form.$children[0].$on("close",()=>{
                        form.$destroy(true);
                        this.$el.removeChild(form.$el);
                    })
                    return form
                }
                return null
            },
            showDot(row){
                if(row.status==1){
                    return false
                }
                return true
            },
            onSaveSuc:function (row) {
                this.$refs.Message._refrash();
            },
            Reflash(){
                this.$refs.Message._refrash();
            },
            onMultipleSelect(selects,ids){
                this.showReadBtn = (selects.length != 0)
            },
            //设置已读
            handleSetRead: function(){
                var ids = this.$refs.Message._getSelectionIDs();
                if(ids.length==0){
                    util.msgWarning("请选择消息")
                    return
                }
                let url = "server/system/Message.ashx?cmd=SetRead"
                let para = {ids:ids.join(",")}
                util.post(url,para,null,result=> {
                    util.msgSuc("设置成功")
                    this.Reflash()
                })
            }
        },
        created(){

        }
    }
</script>
<style scoped>
    .detail{
        color: black;
        text-decoration:none;
    }
    .detail:hover{
        color: #13c19f;
    }
    .message-dot {
        position: absolute;
        top: 9px;
        left: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #f33333;
        margin-top:5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue